// extracted by mini-css-extract-plugin
export var divider = "_jk-0";
export var systemMessage = "_jk-1";